import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPantheonComponent } from './simple-icons-pantheon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPantheonComponent ],
    exports:      [ SimpleIconsPantheonComponent ],
    bootstrap:    []
})
export class SimpleIconsPantheonModule {}
